export const langList = [
    { code: 'cs', name: 'Čeština' },
    { code: 'en', name: 'English' },
];
